"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.neutralColor = void 0;
exports.neutralColor = {
    low: {
        pure: '#000000',
        light: '#A3A3A3',
        medium: '#666666',
        dark: '#292929'
    },
    high: {
        pure: '#FFFFFF',
        light: '#F5F5F5',
        medium: '#E0E0E0',
        dark: '#CCCCCC'
    }
};
